import {getRandomValueByRange} from "../assets";

const DummyArrayOfMillion = [getRandomValueByRange(1000000,10000000), getRandomValueByRange(1000000,10000000), getRandomValueByRange(1000000,10000000), getRandomValueByRange(1000000,10000000), getRandomValueByRange(1000000,10000000), getRandomValueByRange(1000000,10000000),]

const DummyArrayOfThousand = [getRandomValueByRange(1000,999999), getRandomValueByRange(1000,999999), getRandomValueByRange(1000,999999), getRandomValueByRange(1000,999999), getRandomValueByRange(1000,999999), getRandomValueByRange(1000,999999), getRandomValueByRange(1000,999999), getRandomValueByRange(1000,999999), ]

const DummyArrayOfHundred = [getRandomValueByRange(1,999), getRandomValueByRange(1,999), getRandomValueByRange(1,999), getRandomValueByRange(1,999), getRandomValueByRange(1,999), getRandomValueByRange(1,999), ]

function DummyArrayOfPercentage(num) {
    const arr = [];
    var total = 0;
    const final = [];
    for (let i = 0; i < num; i++){
       arr.push(getRandomValueByRange(1,999));
    }  

    for (let i = 0; i < num; i++){
        total = total + arr[i];
    }

    for (let i = 0; i < num; i++){
        final.push(((arr[i]/total)*100).toFixed(2));
    }

    return final;

}

export {DummyArrayOfPercentage};

export var Users = [
    {
        id: 1,
        firstName: "Zahid",
        lastName: "",
        email: "zahid@zahid.com",
        behaveAs: "Admin",
        createdDate: "Fri Mar 19 2021 17:56:07 GMT+0500 (Pakistan Standard Time)",
        isBlocked: true,
        role: "Team Lead"
    },
    {
        id: 2,
        firstName: "Faizan",
        lastName: "Rajab",
        email: "faizan@faizi.com",
        behaveAs: "Super Admin",
        createdDate: "Fri Mar 19 2021 17:56:07 GMT+0500 (Pakistan Standard Time)",
        isBlocked: false,
        role: "Team Lead"
    },
    {
        id: 3,
        firstName: "Usama",
        lastName: "Ikram",
        email: "usama@usama.com",
        behaveAs: "Employee",
        createdDate: "Fri Mar 19 2021 17:56:07 GMT+0500 (Pakistan Standard Time)",
        isBlocked: true,
        role: "Team Lead"
    }
]

export var TeamData = [
    {
        teamId: 1,
        teamTitle: 'LA-0215',
        memberName: 'John',
        designation: 'Manager',
        experience: 8,
    },
    {
        teamId: 2,
        teamTitle: 'LA-0216',
        memberName: 'Marshall',
        designation: 'Programming Lead',
        experience: 12,
    },
    {
        teamId: 3,
        teamTitle: 'LA-0217',
        memberName: 'Snow',
        designation: 'Angular Team Lead',
        experience: 9,
    },
    {
        teamId: 4,
        teamTitle: 'LA-0218',
        memberName: 'Dev',
        designation: 'Django Team Lead',
        experience: 7,
    },
    {
        teamId: 5,
        teamTitle: 'LA-0219',
        memberName: 'Richerd',
        designation: 'JavaScript Team Lead',
        experience: 8,
    },
    {
        teamId: 6,
        teamTitle: 'LA-0220',
        memberName: 'Monica',
        designation: 'Python Team Lead',
        experience: 6,
    },
    {
        teamId: 7,
        teamTitle: 'LA-0221',
        memberName: 'Geller',
        designation: '.Net Team Lead',
        experience: 8,
    },
    {
        teamId: 8,
        teamTitle: 'LA-0222',
        memberName: 'Ross',
        designation: 'React.js Team Lead',
        experience: 10,
    },
    {
        teamId: 9,
        teamTitle: 'LA-0223',
        memberName: 'Joey',
        designation: 'Android Team Lead',
        experience: 6,
    },
    {
        teamId: 10,
        teamTitle: 'LA-0224',
        memberName: 'Chandler',
        designation: 'Manager',
        experience: 5,
    },
] 

export const SuggestionData = [
    {
        suggestionId: 0,
        title: "Make changes in UI",
        description: "changes in user list",
        status: "Done",
        isAnon: true,
    },
    {
        suggestionId: 1,
        title: "Make changes in backend",
        description: "changes in employee crud",
        status: "Refuse",
        isAnon: true,
    },
    {
        suggestionId: 2,
        title: "To do list",
        description: "to do list not working properly",
        status: "Pending",
        isAnon: true,
    },
    {
        suggestionId: 3,
        title: "Make changes in UI",
        description: "changes in user list",
        status: "Done",
        isAnon: true,
    },
    {
        suggestionId: 4,
        title: "To do list",
        description: "to do list not working properly",
        status: "Pending",
        isAnon: true,
    },
    {
        suggestionId: 5,
        title: "Make changes in UI",
        description: "changes in user list",
        status: "Done",
        isAnon: true,
    },
    {
        suggestionId: 6,
        title: "To do list",
        description: "to do list not working properly",
        status: "Pending",
        isAnon: true,
    },
    {
        suggestionId: 7,
        title: "Make changes in UI",
        description: "changes in user list",
        status: "Done",
        isAnon: true,
    },
]

export let FileData = [
    {
        id: 1,
        title: "Work",
        category: "Development",
        date: "2021-11-24",
        shareWith: "--",
        Onwer: "George",
        downloadBy: "Barnard",
        lastDownLoad: "2021-11-24",
        lastUpdate: "2021-11-24",
        fileSize: "40 MB",
    },
    {
        id: 2,
        title: "Holidays",
        category: "Development",
        date: "2021-11-24",
        shareWith: "--",
        Onwer: "George",
        downloadBy: "Andrea",
        lastDownLoad: "2021-11-24",
        lastUpdate: "2021-11-24",
        fileSize: "30 MB",
    },
    {
        id: 3,
        title: "Work",
        category: "Development",
        date: "2021-11-24",
        shareWith: "--",
        Onwer: "George",
        downloadBy: "Herry",
        lastDownLoad: "2021-11-24",
        lastUpdate: "2021-11-24",
        fileSize: "20 MB",
    },
    {
        id: 4,
        title: "Work",
        category: "Development",
        date: "2021-11-24",
        shareWith: "--",
        Onwer: "George",
        downloadBy: "Wick",
        lastDownLoad: "2021-11-24",
        lastUpdate: "2021-11-24",
        fileSize: "25 MB",
    },
    {
        id: 5,
        title: "Work",
        category: "Development",
        date: "2021-11-24",
        shareWith: "--",
        Onwer: "Jerry",
        downloadBy: "Jason",
        lastDownLoad: "2021-11-24",
        lastUpdate: "2021-11-24",
        fileSize: "22 MB",
    },
    {
        id: 6,
        title: "Work",
        category: "Development",
        date: "2021-11-24",
        shareWith: "--",
        Onwer: "George",
        downloadBy: "Smith",
        lastDownLoad: "2021-11-24",
        lastUpdate: "2021-11-24",
        fileSize: "1 MB",
    },
    {
        id: 7,
        title: "Work",
        category: "Development",
        date: "2021-11-24",
        shareWith: "--",
        Onwer: "John",
        downloadBy: "Liza",
        lastDownLoad: "2021-11-24",
        lastUpdate: "2021-11-24",
        fileSize: "3 MB",
    }
]

export const departmentdata = [
    {
        deptId: 1,
        deptName: "Web Development",
        deptHead: "John Smith",
        totalEmployee: 102
    },
    
    {
        deptId: 2,
        deptName: "Marketing",
        deptHead: "Maryam Amiri",
        totalEmployee: 13
    },
    {
        deptId: 3,
        deptName: "App Development",
        deptHead: "Frank Camly",
        totalEmployee: 21
    },
    {
        deptId: 4,
        deptName: "Support",
        deptHead: "Gary Camara",
        totalEmployee: 84
    },
    {
        deptId: 5,
        deptName: "Accounts",
        deptHead: "Fidel Tonn",
        totalEmployee: 11
    },
    {
        deptId: 6,
        deptName: "PHP Open Source",
        deptHead: "Maryam Amiri",
        totalEmployee: 37
    },
    {
        deptId: 7,
        deptName: "Design and Printing",
        deptHead: "Maryam Amiri",
        totalEmployee: 102
    },
]